import { render, staticRenderFns } from "./ManagementGiftView.vue?vue&type=template&id=158e8e52&scoped=true"
import script from "./ManagementGiftView.vue?vue&type=script&lang=js"
export * from "./ManagementGiftView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158e8e52",
  null
  
)

export default component.exports